import React from 'react';

const designSystem = {
  colors: {
    primary: 'rgb(5, 94, 253)',
    background: 'rgb(255, 255, 255)',
    lightBackground: 'rgb(249, 249, 251)',
    text: 'rgb(34, 35, 36)',
    textSecondary: 'rgb(107, 114, 126)',
    border: 'rgb(229, 231, 235)'
  },
  typography: {
    fontFamily: 'Inter, sans-serif',
    fontWeights: { medium: 500, semibold: 600, bold: 700 }
  },
  borderRadius: '4px',
  spacing: { xs: '4px', sm: '8px', md: '12px', lg: '16px', xl: '24px' }
};

const TraitSlider = ({ 
  traitName, 
  value, 
  options, 
  description, 
  exampleResponse, 
  onChange, 
  isMobile 
}) => {
  const getSliderValue = (value) => options.indexOf(value);
  const getValueFromSlider = (sliderValue) => options[sliderValue];

  return (
    <div style={{
      backgroundColor: designSystem.colors.lightBackground,
      padding: designSystem.spacing.lg,
      borderRadius: designSystem.borderRadius,
      marginBottom: designSystem.spacing.lg,
      border: `1px solid ${designSystem.colors.border}`
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: designSystem.spacing.sm,
        flexWrap: 'wrap',
        gap: designSystem.spacing.xs
      }}>
        <h4 style={{
          fontFamily: designSystem.typography.fontFamily,
          fontSize: isMobile ? '14px' : '16px',
          fontWeight: designSystem.typography.fontWeights.semibold,
          color: designSystem.colors.text,
          margin: 0
        }}>
          {traitName.charAt(0).toUpperCase() + traitName.slice(1)}
        </h4>
        <span style={{
          fontFamily: designSystem.typography.fontFamily,
          fontSize: '12px',
          color: designSystem.colors.primary,
          fontWeight: designSystem.typography.fontWeights.medium,
          backgroundColor: 'rgb(239, 246, 255)',
          padding: `${designSystem.spacing.xs} ${designSystem.spacing.sm}`,
          borderRadius: designSystem.borderRadius
        }}>{value}</span>
      </div>
      
      <p style={{
        fontFamily: designSystem.typography.fontFamily,
        color: designSystem.colors.textSecondary,
        fontSize: isMobile ? '12px' : '13px',
        marginBottom: designSystem.spacing.md,
        lineHeight: '1.4'
      }}>{description}</p>
      
      <div style={{ marginBottom: designSystem.spacing.md }}>
        <input
          type="range"
          min="0"
          max={options.length - 1}
          value={getSliderValue(value)}
          onChange={(e) => onChange(traitName, getValueFromSlider(parseInt(e.target.value)))}
          style={{
            width: '100%',
            height: isMobile ? '8px' : '6px',
            borderRadius: '3px',
            background: `linear-gradient(to right, ${designSystem.colors.primary} 0%, ${designSystem.colors.primary} ${(getSliderValue(value) / (options.length - 1)) * 100}%, ${designSystem.colors.border} ${(getSliderValue(value) / (options.length - 1)) * 100}%, ${designSystem.colors.border} 100%)`,
            outline: 'none',
            cursor: 'pointer',
            WebkitAppearance: 'none',
            appearance: 'none'
          }}
        />
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: designSystem.spacing.xs
        }}>
          <span style={{
            fontFamily: designSystem.typography.fontFamily,
            fontSize: '10px',
            color: designSystem.colors.textSecondary
          }}>{options[0]}</span>
          <span style={{
            fontFamily: designSystem.typography.fontFamily,
            fontSize: '10px',
            color: designSystem.colors.textSecondary
          }}>{options[options.length - 1]}</span>
        </div>
      </div>

      {exampleResponse && (
        <div style={{
          backgroundColor: designSystem.colors.background,
          padding: designSystem.spacing.sm,
          borderRadius: designSystem.borderRadius,
          border: `1px solid ${designSystem.colors.border}`
        }}>
          <span style={{
            fontFamily: designSystem.typography.fontFamily,
            fontSize: '11px',
            color: designSystem.colors.textSecondary
          }}>
            <strong>Example:</strong> "{exampleResponse}"
          </span>
        </div>
      )}
    </div>
  );
};

export default TraitSlider;